import {
  AfterViewInit,
  Directive,
  ElementRef,
  inject,
  input,
  Renderer2,
} from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Directive({
  selector: '[libRequired]',
})
export class Required implements AfterViewInit {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);

  ngAfterViewInit(): void {
    const star = this.renderer.createElement('span');
    this.renderer.setStyle(star, 'color', 'red');
    const starText = this.renderer.createText(' *');
    this.renderer.appendChild(star, starText);
    this.renderer.appendChild(this.el.nativeElement, star);
  }
}
